"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedErrorGrid = exports.SharedErrorWrapper = void 0;
var material_1 = require("@mui/material");
exports.SharedErrorWrapper = (0, material_1.styled)(material_1.Box)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(2),
        padding: theme.spacing(1.5),
        maxWidth: 600,
    });
});
exports.SharedErrorGrid = (0, material_1.styled)(material_1.Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'grid',
            gridTemplateColumns: 'auto 1fr'
        },
        _b[theme.breakpoints.down('sm')] = {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: theme.spacing(1),
        },
        _b);
});
